import { render, staticRenderFns } from "./CommentIndexView.vue?vue&type=template&id=2c00154d&scoped=true"
import script from "./CommentIndexView.vue?vue&type=script&lang=js"
export * from "./CommentIndexView.vue?vue&type=script&lang=js"
import style0 from "./CommentIndexView.vue?vue&type=style&index=0&id=2c00154d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c00154d",
  null
  
)

export default component.exports